import React from "react";
import { InputAdornment, TextField } from "@material-ui/core";
import { FormikErrors, FormikTouched, getIn } from "formik";

interface IProps {
    disabled?: boolean;
    propName: string;
    label?: string;
    type?: string;
    minRows?: number;
    maxRows?: number;
    multiline?: boolean;
    endIcon?: JSX.Element;
    errors: FormikErrors<any>;
    touched: FormikTouched<any>;
    values: any;
    handleBlur: {
        (e: React.FocusEvent<any>): void;
        <T = string | any>(fieldOrEvent: T): T extends string ? (e: any) => void : void;
    };
    handleChange: {
        (e: React.ChangeEvent<any>): void;
        <T = string | React.ChangeEvent<any>>(field: T): T extends React.ChangeEvent<any> ? void : (e: string | React.ChangeEvent<any>) => void;
    };
    valueGetter?: () => any;
    onChange?: (handler: any) => (e: any) => void;
}

class FormTextField extends React.Component<IProps> {

    render(): JSX.Element {
        const { disabled, propName, label, type, multiline, minRows, maxRows, values, touched, errors, endIcon, handleChange, handleBlur, valueGetter, onChange } = this.props;

        const nestedProp = propName.indexOf(".") > -1;
        const errorFn = () => {
            if (!nestedProp) {
                return Boolean(touched[propName] && errors[propName]);
            }

            return Boolean(
                getIn(touched, propName) &&
                getIn(errors, propName)
            )
        };

        const helperFn = () => {
            if (!nestedProp) {
                return touched[propName] && errors[propName];
            }

            return (
                getIn(touched, propName) &&
                getIn(errors, propName)
            )
        };

        const changeImpl = onChange ? onChange(handleChange) : handleChange;

        return (
            <TextField
                id={propName}
                name={propName}
                disabled={disabled}
                style={{ flex: 1, margin: '0 3px' }}
                type={type}
                minRows={minRows}
                maxRows={maxRows}
                multiline={multiline}
                InputProps={{
                    endAdornment: endIcon ? (
                        <InputAdornment position="end">{endIcon}</InputAdornment>
                    ) : null
                }}
                label={label}
                InputLabelProps={{ shrink: true }}
                value={valueGetter ? valueGetter() : values[propName] ?? ""}
                fullWidth
                onChange={changeImpl}
                onBlur={handleBlur}
                error={errorFn()}
                helperText={helperFn()}
            >
            </TextField>
        )
    }
}

export default FormTextField;
